<template>
  <v-container style="max-width: 100%">
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-img class='align-center' :src="require('@/assets/images/sub.jpg')">
          <div class="text-center white--text py-5">
            <div class="text-sm-h3 pt-5 font-weight-bold" style="font-size: 1.5rem">회사소개</div>
            <div class="text-sm-h5 py-5" style="font-size: 1.0rem">인피니티투자자문을 소개합니다.</div>
          <!-- <div class='text-center white--text'><span class="sub_01">회사소개</span><br> -->
          <!-- <span class="sub_02">고객에게 신뢰받는 기업, 인피니티투자자문을 소개합니다.</span> -->
          </div>
        </v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-tabs
          v-model="model"
          centered
          slider-color="white"
          color="white"
          background-color="red darken-4"
          dark
          active-class="white red--text"
          replace
        >
          <v-tab
            v-for="(menu, i) in menus"
            :key="i"
            :href="`#tab-${i+1}`"
          >
            {{menu.title}}
          </v-tab>
        </v-tabs>

        <v-container class="px-1">
          <div :class="$vuetify.breakpoint.mobile ? 'col-12 pa-0' : 'col-8 mx-auto'">
          <!-- <div :class="$vuetify.breakpoint.mobile ? '' : 'row justify-center'"> -->
          <!-- <div class="row justify-center pb-5">   -->
            <v-tabs-items v-model="model">
              <v-tab-item
                v-for="(menu, i) in menus_src"
                :key="i"
                :value="`tab-${i+1}`"
                eager
              >
                <v-card flat>
                  <v-img eager :src="menu.img" />

                  <v-card flat v-if="model ==='tab-1'">
                    <v-divider class="red darken-4" style="padding-top: 1.1px"></v-divider>
                      <v-row dense class="text-center align-center py-5">
                        <v-col cols="4">
                          <div class="body-1 font-weight-bold pb-2" style="color:#B71C1C; font-size: 18px;">회사명</div>
                          <div class="black--text body-2 font-weight-bold" style="color:#B71C1C; font-size: 16px;">인피니티투자자문㈜</div>
                        </v-col>
                        <v-col cols="4">
                          <div class="body-1 font-weight-bold pb-2" style="color:#B71C1C; font-size: 18px;">대표이사</div>
                          <div class="black--text body-2 font-weight-bold" style="color:#B71C1C; font-size: 16px;">나홍규</div>
                        </v-col>
                        <v-col cols="4" class="px-0">
                          <div class="body-1 font-weight-bold pb-2" style="color:#B71C1C; font-size: 18px;">전화번호 / FAX</div>
                          <div class="black--text body-2 font-weight-bold" style="color:#B71C1C; font-size: 16px;">02) 784-7670 / 02) 784-7677</div>
                        </v-col>
                      </v-row>
                    <v-divider></v-divider>
                    <v-row dense class="text-center align-center py-5">
                        <v-col cols="4">
                          <div class="body-1 font-weight-bold pb-2" style="color:#B71C1C; font-size: 18px;">자본금</div>
                          <div class="black--text body-2 font-weight-bold" style="color:#B71C1C; font-size: 16px;">{{capital}}억원</div><br>
                        </v-col>
                        <v-col cols="4">
                          <div class="body-1 font-weight-bold pb-2" style="color:#B71C1C; font-size: 18px;">본사</div>
                          <div class="black--text body-2 font-weight-bold" style="color:#B71C1C; font-size: 16px;">서울특별시 영등포구 국제금융로2길 32<br>13층(여의도동, 여의도파이낸스타워)</div>
                        </v-col>
                        <v-col cols="4">
                          <div class="body-1 font-weight-bold pb-2" style="color:#B71C1C; font-size: 18px;">홈페이지</div>
                          <div class="black--text body-2 font-weight-bold" style="color:#B71C1C; font-size: 16px;">http://www.infinityasset.com</div><br>
                        </v-col>
                      </v-row>
                    <v-divider class="pb-5"></v-divider>

                    <v-row class="px-1">
                      <v-col
                        v-for="(item, i) in banner"
                        :key="i"
                        cols="4"
                        class="px-2"
                      >
                        <v-card outlined min-height="240px" max-height="380px">
                          <v-card-title class="justify-center font-weight-bold py-10 px-0" :class="$vuetify.breakpoint.mobile ? 'subtitle-1' : 'text-h6'" style="color:#B71C1C">
                            <span v-html="item.title"></span>
                          </v-card-title>
                          <v-img :src="item.image" width="200px" class="mx-auto"></v-img>
                          <v-card-title class="justify-center body-1 font-weight-bold">
                            <span v-html="item.subtitle"></span>
                          </v-card-title>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>

                </v-card>
              </v-tab-item>
              <v-tab-item value='tab-5' >
                <v-card flat>
                  <DaumMap />
                  <!-- <div style="width:1200px;"> -->
                  <v-simple-table class="pt-5">
                    <tbody>
                      <tr
                        v-for="item in datas"
                        :key="item.name"
                        class="text-h6"
                      >
                        <td style="border-bottom-style: none !important; height: 35px">{{ item.title }}</td>
                        <td style="border-bottom-style: none !important; height: 35px">{{ item.text }}</td>
                      </tr>
                    </tbody>

                  </v-simple-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DaumMap from '@/components/DaumMap';

  export default {
    components: {DaumMap},
    data: () => ({
      model: '',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
       menus: [
        { title: '회사개요', img: require('@/assets/images/menu1-1.jpg') },
        { title: '회사연혁', img: require('@/assets/images/menu1-2.jpg') },
        { title: '경영철학', img: require('@/assets/images/menu1-3.jpg') },
        { title: '조직도', img: require('@/assets/images/menu1-4.jpg') },
        { title: '찾아오시는 길', img: ''}
      ],
       menus_src: [
        { title: '회사개요', img: require('@/assets/images/menu1-1_bk.jpg') },
        { title: '회사연혁', img: require('@/assets/images/menu1-2.jpg') },
        { title: '경영철학', img: require('@/assets/images/menu1-3.jpg') },
        { title: '조직도', img: require('@/assets/images/menu1-4.jpg') },
      ],
      /*
      banner: [
        {image: require('@/assets/images/menu1_banner01.png'), page: '?menu=2&page=tab-4', title: '설립일', subtitle: "<div class='py-5'>2002년 2월 9일</div>"},
        {image: require('@/assets/images/menu1_banner02.png'), page: '?menu=2&page=tab-3', title: '수탁고<b style="font-size: 0.95rem;">(2025년 6월 30일 기준)</b>', subtitle: "<div class='text-center pb-4'>2,314억원<br>(일임, 자문포함 NAV 기준)</div>"},
        {image: require('@/assets/images/menu1_banner03.png'), page: '?menu=4&page=tab-1', title: '임직원수', subtitle: "<div class='py-5'>9명</div>"}
      ],
      */
      datas: [
        { title: '주소', text: '07327 서울특별시 영등포구 국제금융로2길 32, 13층(여의도동, 여의도파이낸스타워)'},
        { title: '대표전화', text: '02-784-7670'},
        { title: '팩스', text: '02-784-7677'},
        { title: '이메일', text: 'contact@infinityasset.com'}
      ],
      view_map: false,
      capital: 28.7, // 자본금
      aumBaseDt: '2025년 6월 30일', // 수탁고 기준일
      aum: 2314, // 수탁고
      empCnt: 9 // 임직원수
    }),
    created() {
      this.$http.get(`${process.env.VUE_APP_API_URL}/getCompInfo`)
        .then(response => {
          if (response.status === 200 && response.data.length > 0) {
            const data = response.data[0];
            // 기본 회사 정보
            this.capital = Number(data.CAPITAL / 100000000);
            this.aum = Number(data.AUM);
            this.empCnt = Number(data.EMP_CNT);

            // 이미 서버에서 포맷된 값
            this.aumBaseDt = data.AUM_BASE_DATE_KR;
          }
        })
        .catch(error => {
          console.error("API 요청 실패:", error);
        });
    },
    mounted() {
      this.model = this.$route.query.page;
    },
    methods: {
    /*
      goPage(tab) {
        this.$router.push('/menu01?page=tab-'+Number(tab));
      }
    */
    },
    computed: {
      banner () {
        return [
          {
            image: require('@/assets/images/menu1_banner01.png'),
            page: '?menu=2&page=tab-4',
            title: '설립일',
            subtitle: "<div class='py-5'>2002년 2월 9일</div>"
          },
          {
            image: require('@/assets/images/menu1_banner02.png'),
            page: '?menu=2&page=tab-3',
            title: `수탁고<b style="font-size:0.95rem;">(${this.aumBaseDt} 기준)</b>`,
            subtitle: `
              <div class='text-center pb-4'>
                ${this.aum.toLocaleString()}억원<br>
                (일임, 자문포함 NAV 기준)
              </div>
            `
          },
          {
            image: require('@/assets/images/menu1_banner03.png'),
            page: '?menu=4&page=tab-1',
            title: '임직원수',
            subtitle: `<div class='py-5'>${this.empCnt}명</div>`
          }
        ]
      }
    }
  }
</script>

<style>
.v-tabs{
  margin-bottom: 80px;

}

.v-tab.v-tab{
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: 0rem;
  padding: 0 60px;
}

.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn, .theme--dark.v-tabs > .v-tabs-bar .v-tab--disabled{
  color: #ffffff !important;
}

.sub_01{
  font-size:3.375rem ;
  font-weight: 700;
}
.sub_02{
  font-size:1.625rem;
}


</style>

